import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Martín G., 45',
    city: 'Pergamino',
    text: 'Doy clases en escuela rural hace 12 años. Siempre tuve que adaptar material urbano. Con este kit tengo todo listo y mis alumnos por fin conectan con lo que ven todos los días en el campo.',
    role: 'Profesor de Geografía Rural'
  }, {
    name: 'Carolina V., 33',
    city: 'Rafaela',
    text: 'Las actividades de campo son increíbles. Mis alumnos salen a observar el entorno y aplican lo que aprendieron. Nunca tuve un material así de completo.',
    role: 'Docente de Geografía'
  }, {
    name: 'Jorge M., 52',
    city: 'Río Cuarto',
    text: 'El tomo de geografía agraria me resolvió todo un trimestre. La estructura es clara y las evaluaciones están listas. Lo recomiendo a cualquier docente rural.',
    role: 'Profesor de Nivel Medio'
  }, {
    name: 'Lucía P., 38',
    city: 'Tandil',
    text: 'La planificación anual es oro puro. Antes improvisaba semana a semana, ahora tengo todo el año resuelto. Mis alumnos notan la diferencia.',
    role: 'Profesora de Geografía'
  }, {
    name: 'Fernando R., 48',
    city: 'Entre Ríos',
    text: 'Compramos el Sistema Pro para toda el área de geografía de nuestra escuela agrotécnica. La calidad del contenido y las evaluaciones nos ahorraron meses de trabajo.',
    role: 'Director de Escuela Agrotécnica'
  }];
  return <section className="bg-[#071A14] py-4 md:py-6 px-3 border-b border-[#1F3D2B]" data-id="element-215">
      <div className="max-w-5xl mx-auto" data-id="element-216">
        <h2 className="text-xl md:text-2xl font-black text-white text-center mb-4 uppercase tracking-tight" data-id="element-217">
          💬 TESTIMONIOS
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-3" data-id="element-218">
          {testimonials.map((t, i) => <div key={i} className="bg-[#102A1F] border border-[#1F3D2B] p-3 rounded-lg flex flex-col shadow-lg" data-id="element-219">
              <div className="text-[#D4A843] text-xs mb-1.5 tracking-widest" data-id="element-220">
                ★★★★★
              </div>
              <p className="text-[#BFC9C5] font-bold text-xs mb-3 flex-grow italic leading-snug" data-id="element-221">
                "{t.text}"
              </p>
              <div className="border-t border-[#1F3D2B] pt-2" data-id="element-222">
                <p className="font-black text-white text-xs uppercase" data-id="element-223">
                  {t.name}
                </p>
                <p className="text-[9px] md:text-[10px] font-bold text-[#74C69D] uppercase mt-0.5" data-id="element-224">
                  {t.role} • {t.city}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}